// extracted by mini-css-extract-plugin
export default {"header":"confirm_modal___header___b1b81adb","dialog":"confirm_modal___dialog___ecd58f84"};